import { useTranslation } from 'react-i18next';
import { envVariableOrDefault } from '../../shared/app/constants';

// TODO: Replace links when released.
// #Task 18774: Configure Apps links
const APP_STORE_LINK = envVariableOrDefault(
  '$APP_APPSTORE_URL',
  'https://apps.apple.com/us/app/prisma-app/id1473392991'
);
const GOOGLE_PLAY_LINK = envVariableOrDefault(
  '$APP_GOOGLE_PLAY_URL',
  'https://play.google.com/store/apps/details?id=com.lmt.sleeppatientapp'
);

type Props = {
  appStore: 'Apple' | 'Google';
};

export const AppStoreButton = (props: Props) => {
  const { i18n } = useTranslation();

  let language = i18n?.language ?? 'en';

  // There is case when language displayed as `en_US`.
  // We need to slice it to 2 digits, like this: `en`.
  if (language.length > 2) {
    language = language.substring(0, 2);
  }

  let link = '';
  let storeImg = '';

  switch (props.appStore) {
    case 'Apple':
      link = APP_STORE_LINK;
      try {
        storeImg = require(`../../assets/images/badges/ios/badge-${language}.svg`);
      } catch (e: any) {
        throw new Error(`Badge for iOS with ${language} not found!`);
      }
      break;

    case 'Google':
      link = GOOGLE_PLAY_LINK;
      try {
        storeImg = require(`../../assets/images/badges/android/badge-${language}.png`);
      } catch (e: any) {
        throw new Error(`Badge for Android with ${language} not found!`);
      }
      break;
  }

  return (
    <a href={link} target={'_blank'} rel="noreferrer">
      <img src={storeImg} alt={''} style={{ maxHeight: '38px' }} />
    </a>
  );
};
